import React from 'react';
import { useNavigate } from 'react-router-dom';
import SeatsHotspot from '../components/hotspots/SeatsHotspot';
import ConcessionsHotspot from '../components/hotspots/ConcessionsHotspot';

function Athletics() {
  const navigate = useNavigate();

  return (
    <div className="page athleticsPage">
      <div className="page-header">Athletics</div>

      <div className="text-blocks">
        <div className="std-text">
          Create distinctive, personalized experiences for students through innovative
          point-of-sale payments, kiosk, and mobile ordering designed specifically for
          stadiums &amp; arenas dining.
        </div>
        <div className="std-text">
          These solutions help automate many of the labor-intensive transactional tasks,
          freeing up staff to spend more quality time focused on delivering a more
          personalized, higher touch dining experience.
        </div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus')}>
        <img src="/assets/higher-ed/agilysys-wordmark.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>

      <div className="athletics-map">
        <div className="seats">
          <SeatsHotspot onClick={() => navigate('/athletics/seats')} />
        </div>
        <div className="concessions">
          <ConcessionsHotspot onClick={() => navigate('/athletics/concessions')} />
        </div>
      </div>

      <div className="tap">
        <img src="/assets/higher-ed/solutions/Blue-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
    </div>
  );
}

export default Athletics;
